import * as t from "react";

let e = 0;

/*
    5 % 2 === 5 & 1;
    8 % 4 === 8 & 3;
    9 % 8 === 9 & 7;
*/ const r = t.useId || (() => t.useRef().current ||= `:${(e = e + 1 & 2147483647).toString(36)}:`), o = t => {
    const e = r();
    return t || "id" + e;
};

export { o as default };
//# sourceMappingURL=index.js.map
